import React from 'react'
import { Select, Input, VALIDATION_TYPES } from 'components/Form'
import { FormActionButtons } from 'components/OmniJourney/utils'
import Validity from 'components/AppHome/Validity'
import { getMessage } from 'lib/translator'
import _unset from 'lodash/unset'
import './style.scss'

const RULES_OPTIONS = [
  { text: 'Default', value: 'default' },
  { text: 'Store ID', value: 'by-store-Id' },
  { text: 'Offer ID', value: 'by-offer-Id' },
]

const RULE_TYPE_TO_PROPERTY = {
  'by-store-Id': 'storeIds',
  'by-offer-Id': 'offerIds',
}

const Mapping = ({ scanRule, generateStateMappers, buttons, onSave }) => {
  const handleRuleTypeChange = () => {
    _unset(scanRule, RULE_TYPE_TO_PROPERTY[scanRule.type])
  }

  return (
    <div className="mapping-form">
      <div className="profile-section">
        <h3>Profile</h3>
        <Input
          required
          name="profile-name"
          placeholder="Enter profile name"
          {...generateStateMappers({
            stateKeys: ['description'],
            loseEmphasisOnFill: true,
          })}
        />
      </div>
      <div className="rules-section">
        <h3>Rules</h3>
        <Select
          required
          name="mapping-rule"
          placeholder="Select mapping rule"
          options={RULES_OPTIONS}
          {...generateStateMappers({
            stateKeys: ['scanRule', 'type'],
            loseEmphasisOnFill: true,
            onChange: (val) => {
              console.log('scanRule type changed to', val)
              handleRuleTypeChange()
            },
          })}
        />
        {['by-store-Id', 'by-offer-Id'].includes(scanRule.type) && (
          <Input
            required
            name="id-input"
            placeholder="Enter IDs (comma separated)"
            pattern="^\d+(,\d+)*$"
            {...generateStateMappers({
              stateKeys: ['scanRule', RULE_TYPE_TO_PROPERTY[scanRule.type]],
              loseEmphasisOnFill: true,
              validationType: VALIDATION_TYPES.ONSUBMIT,
            })}
            validationStrings={{
              patternMismatch:
                'Please enter numerical values separated by commas (e.g., 123,456,789)',
            }}
          />
        )}
      </div>
      <div className="validity-section">
        <h3>{getMessage('omni-journey.validity.header')}</h3>
        <Validity
          readOnlyField={false}
          generateStateMappers={generateStateMappers}
        />
      </div>

      <div className="form-buttons-section">
        <FormActionButtons buttons={buttons} onSave={onSave} />
      </div>
    </div>
  )
}

export default Mapping
